import { render, staticRenderFns } from "./GenerateAllVaccinatedCrew.vue?vue&type=template&id=fab94b62&scoped=true&"
import script from "./GenerateAllVaccinatedCrew.vue?vue&type=script&lang=js&"
export * from "./GenerateAllVaccinatedCrew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fab94b62",
  null
  
)

export default component.exports